import { EnumSchema, FromSchema } from '@40seas/entities/common';
import { TenantlessBaseEntity, WithTenantlessBaseEntitySchema } from '@40seas/models';
import { z } from 'zod';
import { AirwallexEnvironment } from './airwallex-environment.enum';

export enum AirwallexBearerTokenStatus {
    ACTIVE = 'active',
    INACTIVE = 'inactive',
}

export const AirwallexBearerTokenSchema = WithTenantlessBaseEntitySchema(
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    //@ts-ignore - Fix TS FS-3199
    z.object({
        token: z.string(),
        environment: EnumSchema(AirwallexEnvironment),
        status: EnumSchema(AirwallexBearerTokenStatus),
    }),
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    //@ts-ignore - Fix TS FS-3199
).strict();

export class AirwallexBearerToken extends FromSchema(AirwallexBearerTokenSchema) implements TenantlessBaseEntity {
    id: string;
    token: string;
    environment: AirwallexEnvironment;
    status: AirwallexBearerTokenStatus;
    createdAt: Date;
    updatedAt: Date;
}
